var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6891 22H7.15545C5.41549 22 4 20.5982 4 18.875V8.28906C4 6.56589 5.41549 5.16406 7.15545 5.16406H14.6891C16.4291 5.16406 17.8445 6.56589 17.8445 8.28906V18.875C17.8445 20.5982 16.4291 22 14.6891 22ZM7.15545 6.72656C6.28555 6.72656 5.57773 7.42755 5.57773 8.28906V18.875C5.57773 19.7365 6.28555 20.4375 7.15545 20.4375H14.6891C15.559 20.4375 16.2668 19.7365 16.2668 18.875V8.28906C16.2668 7.42755 15.559 6.72656 14.6891 6.72656H7.15545ZM21 16.9219V5.125C21 3.40182 19.5845 2 17.8445 2H9.08817C8.65244 2 8.2993 2.34973 8.2993 2.78125C8.2993 3.21277 8.65244 3.5625 9.08817 3.5625H17.8445C18.7145 3.5625 19.4223 4.26349 19.4223 5.125V16.9219C19.4223 17.3534 19.7754 17.7031 20.2111 17.7031C20.6469 17.7031 21 17.3534 21 16.9219Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ba44d081e8da64e1e5d339c0ee6fbac2.svg";
export { ForwardRef as ReactComponent };